import { ComponentType } from '~/shared/domain/models';
import type { ContentfulFieldHidden } from '~/services/origins/contentful';
import type { FieldHiddenSchema } from '~/shared/domain/models';

export const adaptFieldHidden = (field: ContentfulFieldHidden): FieldHiddenSchema => {
  if (!field?.fields) {
    throw new Error('Missing field hidden params');
  }

  const { fields } = field;

  return {
    componentType: ComponentType.FieldHidden,
    name: fields.name,
    defaultValue: fields.defaultValue,
  };
};
